import { AppStateWithData } from "../../../../AppStateWithData";
import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { FileAttachment, Comment } from "../../../../../models";
import { CommentResponse, proccessSingleCommentResponse } from "./processCommentsResponse";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { CommentState } from "../commentsReducer";

interface NewCommentRequest {
    docId: string
    text: string
    attachments: FileAttachment[],
    tempId?: string,
    tags?: string[],
}

export interface PostCommentAdditionalData {
    docId: string,
    newUsage?: boolean
    tempId?: string
    tempComment?: CommentState
}

export const postCommentActionTypes = createRequestActionTypes('CREATE_COMMENT')

const prepateCommentRequest = async (docId: string, text: string, constructAttachments: FileAttachment[] | Promise<FileAttachment[]>, tempId: string, tags?: string[]): Promise<NewCommentRequest> => {
    const attachments = await constructAttachments
    return {
        attachments,
        docId,
        text,
        tempId,
        tags
    }
}

type AdditionalOptions = {
    newUsage?: boolean
    tempComment: CommentState
}
export const postComment = (config: ApiConfig) => (docId: string, text: string, constructAttachments: FileAttachment[] | Promise<FileAttachment[]>, tempId: string, tags?: string[], options?: AdditionalOptions) =>
    (dispatch: Dispatch, getState: () => AppStateWithData) => {
        const thunkParams: RequestThunkParameters<Comment, NewCommentRequest, PostCommentAdditionalData> = {
            method: 'POST',
            requestActionTypes: postCommentActionTypes,
            url: `${config.API_URL}/comments`,
            asyncPrepareBody: prepateCommentRequest(docId, text, constructAttachments, tempId, tags),
            actionAdditionalData: {
                docId,
                newUsage: !!options ? options.newUsage : false,
                tempId,
                tempComment: options?.tempComment,
            },
            processResultBeforeDispatch: (response: CommentResponse) => {

                if (config.updateItem) {
                    config.updateItem(docId)
                }

                return proccessSingleCommentResponse(response)
            }
        }
        return dispatch<any>(createRequestThunk(thunkParams))
    }